const empty = [];
export const getStrapiSFUEntires = (state) => {
	return state.Filters.fetchStrapiSFU?.data?.sfu || empty;
};
